import { call, put } from 'redux-saga/effects';
import RegisterActions from '../redux/RegisterRedux';
import { ApiResponse } from '../services/Api';
import { api } from './api';


// attempts to register
export function* register(action: any) {
  const { email, childName, parentName, relation } = action;
  
  try {
    // make the call to the api
    const response: ApiResponse = yield call(api.register, email, childName, parentName, relation);
    console.log("register response", response);
    
    if (response.ok) {
      // dispatch successful registration
      yield put(RegisterActions.registerSuccess(response.data));
    } else {
      // dispatch failure
      yield put(RegisterActions.registerFailure());
    }
  } catch (error) {
    // dispatch failure
    yield put(RegisterActions.registerFailure());
  }
}